import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';

import ClientCount from './homeInfoComponents/ClientCount';
import ActiveCredits from './homeInfoComponents/ActiveCredits';
import VecidoCredits from './homeInfoComponents/VecidoCredits';
import RecuperacionDiaria from './homeInfoComponents/RecuperacionDiaria';
import PendieteCredits from './homeInfoComponents/PendieteCredits';
import MoraTotal from './homeInfoComponents/MoraTotal';
import BlobSize from './homeInfoComponents/BlobSize';
import TasaMorosidad from './homeInfoComponents/TasaMorosidad';
import CreditosPorVencer from './homeInfoComponents/CreditosPorVencer';
import ColocacionMensual from './homeInfoComponents/ColocacionMensual';
import NuevosClientes from './homeInfoComponents/NuevosClientes';
import { DataContext } from '../../context/DataContext';
import { isAccess } from '../../helpers/Helpers';

const SectionLabel = ({ children }) => (
	<Typography
		sx={{
			fontSize: 12.5,
			fontWeight: 600,
			color: 'text.secondary',
			letterSpacing: '.2px',
			marginBottom: '10px'
		}}
	>
		{children}
	</Typography>
);

// Grid auto-ajustable: cada tarjeta ocupa 1 columna (2 en el caso de
// NuevosClientes) y se reacomoda sola sin dejar huecos, sin importar
// cuántas tarjetas opcionales estén habilitadas por permisos.
const CardGrid = ({ children }) => (
	<Box
		sx={{
			display: 'grid',
			gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
			gridAutoFlow: 'dense',
			gap: '16px'
		}}
	>
		{children}
	</Box>
);

const HomeInfo = ({ selectedSucursal }) => {
	const { access } = useContext(DataContext);

	const showRiesgo =
		isAccess(access, 'DASH MOROSIDAD') ||
		isAccess(access, 'DASH PORVENCER') ||
		isAccess(access, 'DASH COLOCACION MENSUAL');

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: '22px' }}>
			<Box>
				<SectionLabel>Cartera</SectionLabel>
				<CardGrid>
					<ClientCount selectedSucursal={selectedSucursal} />
					<ActiveCredits selectedSucursal={selectedSucursal} />
					<VecidoCredits selectedSucursal={selectedSucursal} />
					<PendieteCredits selectedSucursal={selectedSucursal} />
				</CardGrid>
			</Box>

			{showRiesgo ? (
				<Box>
					<SectionLabel>Riesgo y colocación</SectionLabel>
					<CardGrid>
						{isAccess(access, 'DASH MOROSIDAD') ? (
							<TasaMorosidad selectedSucursal={selectedSucursal} />
						) : null}
						{isAccess(access, 'DASH PORVENCER') ? (
							<CreditosPorVencer selectedSucursal={selectedSucursal} />
						) : null}
						{isAccess(access, 'DASH COLOCACION MENSUAL') ? (
							<ColocacionMensual selectedSucursal={selectedSucursal} />
						) : null}
					</CardGrid>
				</Box>
			) : null}

			<Box>
				<SectionLabel>Actividad</SectionLabel>
				<CardGrid>
					<RecuperacionDiaria selectedSucursal={selectedSucursal} />
					<MoraTotal selectedSucursal={selectedSucursal} />
					<BlobSize />
					{isAccess(access, 'DASH NUEVOS CLIENTES') ? (
						<Box sx={{ gridColumn: 'span 2' }}>
							<NuevosClientes selectedSucursal={selectedSucursal} />
						</Box>
					) : null}
				</CardGrid>
			</Box>
		</Box>
	);
};

export default HomeInfo;
